import { NavModalComponent } from "../../../core/component/NavModal.Component";
import { Component, ViewChild, Input, ElementRef } from "@angular/core";
import { SMMessageService } from "../../forms/Communication/Message/SMMessage.service";
import { TemplateService } from "../../forms/organizational-setup/setup/template/template.service";
import { AuthGuard } from "../../../core/helper/auth.guard";
import { LocalStorage } from "../../../core/helper/localStorage";
import { AppConstants } from "../../../app.constant";
import * as moment from 'moment';
import { GenEnum } from "../../shared/general.enum";
import { IXSModalComponent } from "../../../components/ixsmodal/ixsmodal.component";
import { IXSDropdownComponent } from "../../../components/dropdown/dropdown.component";

import { EmployeeinfohdrService } from "../../forms/Employee-Profile/Employeeinfohdr/employee-profile/employee-profile.service";
import { DebugAppView } from "@angular/compiler/src/private_import_core";
import { BaseComponent } from "../../../core/component/Base.Component";
import { FormBuilder, FormGroup } from "@angular/forms";
import { IxsloaderComponent } from "../../../components/ixsloader/ixsloader.component";

@Component({
    moduleId: module.id,
    selector: "Employee-birthday",
    templateUrl: "../Employee-Birthday/EmployeeBirthday.component.html",
})

export class EmployeeBirthday extends BaseComponent {

    localStorage: any;
    teacherid: any;
    @ViewChild(IxsloaderComponent) loader: IxsloaderComponent;
    @ViewChild('empBirthdaymodal') empBirthdaymodal: IXSModalComponent;
    @ViewChild('empdrop') empdrop: IXSDropdownComponent;
    @ViewChild('sms') sms: ElementRef;
    @ViewChild('MobApp') MobApp: ElementRef;

    imageSource: any;
    Firstname: string;
    Empimage: string;
    DOB: string;
    items = [];
    Empage: string;
    Empcode: string;
    myForm: FormGroup;
    protected fb: FormBuilder = new FormBuilder();

    constructor(private EmployeeinfohdrService: EmployeeinfohdrService,
        private auth: AuthGuard,


        private smmessageservice: SMMessageService,
        private templateService: TemplateService,
    ) {
        super();
        this.initilizeForm();
        this.localStorage = AppConstants.injector.get(LocalStorage);
        this.imageSource = AppConstants.urls.api.base.replace("api/", "") + GenEnum.Image.imageUrl;
    }


    initilizeForm() {
        // this.title = "EmployeeBirthday";
        this.myForm = this.fb.group({
            'empdrop': ['', []],
            'sms': ['', []],
            'empMobApp': ['', []],

        });
    }


    async getempbirthdaymodal(event) {

        this.Empimage = event.currentTarget.children[0].children[0].src;
        this.teacherid = event.currentTarget.children[2].innerText;
        this.Firstname = event.currentTarget.children[1].innerText;
        this.DOB = event.currentTarget.children[6].innerText;
        this.Empage = event.currentTarget.children[5].innerText;

        this.Empcode = event.currentTarget.children[7].innerText;
        await this.getsmstemplate();
    }

    async getsmstemplate() {
        this.LookupData.smstemplate = [];
        const dto = await this.templateService.getAll();

        if (dto && dto.IsSuccess) {
            this.LookupData.smstemplate = dto.Data;
        }
    }



    async Sentsmsemp() {

        this.loader.startLoading();

        const result: any = {};
        const Data: any = {};

        // this.items.push({ teacherid: event.currentTarget.id,     
        //     studentid:this.studentid

        let Msgtemplate = this.empdrop.data.filter(o => o.Id == this.empdrop.innerValue)[0];

        if (this.empdrop && this.empdrop.value && Msgtemplate) {

            let msgcaption = Msgtemplate.stxt;
            let msgtxt = Msgtemplate.ltxt;
            let tempalteId = this.empdrop.value;
            let smssent = this.sms && this.sms.nativeElement? this.sms.nativeElement.checked : false;
            let mobappsent = this.MobApp && this.MobApp.nativeElement ? this.MobApp.nativeElement.checked : false;


            if (!smssent && !mobappsent) {

                this.showErrors(" Select Sent Option ")
            }
            else {



                if (Data) {

                    let entityid = Number(this.localStorage.get("selectedEntity"));
                    Data.entityid = entityid;
                    Data.lovstatusid = GenEnum.Activity_Status_Id.Active;
                    Data.msgtypeid = GenEnum.MessageType.Notification;
                    Data.lovsenttoid = GenEnum.SendBy.Individual;
                    Data.senttoid = GenEnum.SendTo.Teacher;
                    Data.title = "";
                    Data.mobileapp = mobappsent;
                    Data.sms = smssent;
                    Data.msgdate = new Date();
                    Data.publishdate = new Date();
                    Data.publishtime = new Date(1970, 1, 1, new Date().getHours() + 5, new Date().getMinutes() + 2, 0);
                    Data.msgtxt = msgtxt;
                    Data.SMMessagelogs = [{ teacherid: this.teacherid }];
                    Data.title = msgcaption;
                    Data.templateid = tempalteId;
                    
                    let json: any = {};
                    json.Data = Data;

                    const result = await this.smmessageservice.save(json);

                    if (result.IsSuccess) {
                        this.loader.stopLoading();

                        $('.modal').modal('hide');
                        this.showSuccess('Record saved successfully...');
                        this.loader.stopLoading();

                        this.empdrop.innerValue = undefined;
                        if (this.sms && this.sms.nativeElement) {
                            this.sms.nativeElement.checked = false;
                        }
                        if (this.MobApp && this.sms.nativeElement) {
                            this.MobApp.nativeElement.checked = false;
                        }
                        this.items = [];
                        // this.Studbirthday.modal.close();
                    }
                    else {
                        this.showErrors(result.Errors);
                    }
                }
            }
            this.loader.stopLoading();
        }
        else {
            this.showErrors("Select Message Template")
        }
        //  this.stopLoading();
    }
}



// WEBPACK FOOTER //
// ./src/app/shell/shell-components/Employee-Birthday/Employeebirthday.component.ts